import React from "react"
import { Link } from "gatsby"

import Title from "../Title"
import Project from "./Project"
import useFilter from "../../constants/useFilter"

import {
  Container,
  SubTitle,
  FilterContainer,
  FilterButton,
  Description,
  Info,
} from "./Projects.styled"
const SearchItems = [
  "All",
  "Javascript",
  "React",
  "Gatsby",
  "Graphql",
  "Node",
  "Markdown",
  "Scss",
  "CSS",
  "HTML"

]

const Projects = ({ projects, title, showLink }) => {
  const [Projects, tag, setTag] = useFilter(projects, "stack")

  return (
    <Container className="projects">
      <Title title={title} />
      {!showLink && (
        <SubTitle>
          From Pure Html,Css to React.JS, Redux, Gatsby.JS, and Node.JS. Check
          out my latest web software development portfolio projects.
        </SubTitle>
      )}
      {!showLink && (
        <FilterContainer>
          {SearchItems.map(item => (
            <FilterButton
              key={item}
              onClick={() => setTag(item)}
              isSelected={tag === item}
            >
              {item}
            </FilterButton>
          ))}
        </FilterContainer>
      )}
      <div className="section-center projects-center">
        {!showLink && (
          <Description>
            {tag === "All" ? (
              <>showing All projects. Use the filter to list them by skill</>
            ) : (
              <>
                {" "}
                Showing <span>{Projects.length}</span> projects filtered by{" "}
                <span>{tag}</span> .{" "}
              </>
            )}
          </Description>
        )}
        {!showLink && Projects.length < 1 ? (
          <Info>There is no project currently based on {tag}</Info>
        ) : (
          Projects?.map((project, index) => {
            return <Project key={project?.id} index={index} {...project} />
          })
        )}
      </div>
      {showLink && (
        <Link to="/projects" className="btn center-btn">
          projects
        </Link>
      )}
    </Container>
  )
}

export default Projects
